export default __webpack_public_path__ + "static/test_1_1-9af9c5dec9e8fa80f087bf6b64f5a2a9.png";